import React from "react";
import { useNavigate } from "react-router-dom";
import { GiCheckMark } from "react-icons/gi";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const TaskComplete = ({ pageTitle, nextLink }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`../${nextLink}`);
  };

  return (
    <div className="task-complete text-center">
      <p>{t("taskComplete.congratulations")}</p>
      <GiCheckMark />
      <p>{t("taskComplete.savedSuccessfully", { task: pageTitle })}</p>
      {nextLink && <Button onClick={handleClick}>{t("common.next")}</Button>}
    </div>
  );
};

export default TaskComplete;
